// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__H3yMX","dragIcon":"Choice_dragIcon__1dFfv","left":"Choice_left__1AUO2","input":"Choice_input__ZJ-qS"};